import firebase from 'firebase'
import Vue from 'vue'
import Vuex from 'vuex'
import { mapGetters, stateAfter } from 'vuex'
import createLogger from 'vuex/dist/logger'
import * as R from 'ramda';
import moment from 'moment'
// import Rx from 'rxjs/Rx'
import { Observable } from 'rxjs/Observable'
import {async} from 'async'
Vue.use(Vuex)
import router from '../router'
// import { Observable } from 'rxjs/Observable';

const logger = createLogger({
    collapsed: false, // auto-expand logged mutations
    filter(mutation, stateBefore, stateAfter) {
        // returns `true` if a mutation should be logged
        // `mutation` is a `{ type, payload }`
        return mutation.type !== "aBlacklistedMutation"
    },
    transformer(state) {
        // transform the state before logging it.
        // for example return only a specific sub-tree
        return state.subTree
    },
    mutationTransformer(mutation) {
        // mutations are logged in the format of `{ type, payload }`
        // we can format it any way we want.
        return mutation.type
    },
    logger: console, // implementation of the `console` API, default `console`
})

const state = {    
    messagesinbox:null,
    contacts:null,
    devices:null,
    selecteddevice:null,
    user:null,
    toastmessage:null,
    fcmToken: null,
}

const getters = {
    messagesinbox: state => state.messagesinbox,
    devices: state => state.devices,
    selecteddevice: state => state.selecteddevice,    
    user: state => state.user,
    contacts: state => state.contacts,
    fcmToken: state => state.fcmToken
}

const mutations = {
    //reducers   
    setUser(state, user) {
        state.user = user
    },
    setContacts(state, contacts) {
        state.contacts = contacts
    },
    setDevices(state, devices) {
        state.devices = devices
    },
    setSelectedDevice(state, selecteddevice) {
        state.selecteddevice = selecteddevice
    },    
    setToastMessage(state, toastmessage) {
        state.toastmessage = toastmessage
    },
    setMessagesInbox(state, messagesinbox) {
        state.messagesinbox = messagesinbox
    },
    logout(state) {
        state.user = null;
        state.messagesinbox = null;        
        state.toastmessage = null; 
        state.devices = null,
        state.selecteddevice = null,        
        state.contacts = null,       
        state.fcmToken = null
    },
    setfcmToken(state, fcmToken) {
        state.fcmToken = fcmToken
    },
}

const actions = {          
    

    async setSelectedDevice(context,selecteddevice) {

        let currentSelectedDevice = context.state.selecteddevice;

        context.commit('setSelectedDevice', selecteddevice)
        context.dispatch('monitorMessagesInbox',selecteddevice)
        context.dispatch('monitorContacts',selecteddevice)
        var unix = moment.utc().unix();
        if (context.state.fcmToken) {
            
            await firebase.database().ref(`users/${context.state.user.uid}/fcmTokens/pwa/${currentSelectedDevice}/${context.state.fcmToken}`).set(null).then(() => {                
                return "token cleared"
            })

            await firebase.database().ref(`users/${context.state.user.uid}/fcmTokens/pwa/${selecteddevice}/${context.state.fcmToken}`).set(unix).then(() => {
                console.log("token sent to server");
                return "token sent to server"
            })
            .catch(ex => {
                console.log(ex);
            });

        }
    },

    async monitorMessagesInbox(context,device) {
        await firebase.database().ref(`users/${firebase.auth().currentUser.uid}/${device}/messagesobject`)
            .on('value', (snapshot) => {
                var messages = snapshot.val()
                context.commit('setMessagesInbox', messages)
            })
    },

    sendDeviceCommand({ commit, state },request){
        
        firebase.database().ref(`users/${firebase.auth().currentUser.uid}/${state.selecteddevice}/devicecommands`).push(
            request
        ).then(() => {
            commit('setToastMessage', { type: 'info', message: `Sending Command ${request.type}`, title: 'Commands' })
        }).catch(ex => {
        });
    },
    sendSMS({ commit, state },messagedetails){
        firebase.database().ref(`users/${firebase.auth().currentUser.uid}/${state.selecteddevice}/sendmessages/sms`).push(
            {
                too:messagedetails.too,
                message:messagedetails.message
            }
        ).then(() => {
            commit('setToastMessage', { type: 'info', message: `Sending`, title: 'SMS' })
        }).catch(ex => {
        });
    },
    setDevices(context) {
        firebase.database().ref(`users/${firebase.auth().currentUser.uid}/devices/`)
        .on('value', (snapshot) => {
            var devices = snapshot.val()            
            context.commit('setDevices', devices)
        })        
    },
    saveDeviceInfo(context,devices){
        firebase.database().ref(`users/${firebase.auth().currentUser.uid}/devices/`)
        .update(devices)

        context.commit('setDevices', devices)
    },
    monitorContacts(context,device) {
        firebase.database().ref(`users/${firebase.auth().currentUser.uid}/${device}/contacts`)
            .on('value', (snapshot) => {
                var contacts = snapshot.val()
                context.commit('setContacts', contacts)
            })
    },

    // logUserInFacebook({ commit, state }) {
    //     var provider = new firebase.auth.FacebookAuthProvider();
    //     provider.addScope("email");
    //     firebase
    //         .auth()
    //         .signInWithPopup(provider)
    //         .then(result => {                
    //             commit('setToastMessage', { type: 'info', message: `${result.user.displayName} you are logged in with your Facebook account`, title: 'Facebook Login' })
    //         });
    // },

    logUserInGoogle({ commit, state }) {
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope("profile");
        provider.addScope("email");
        firebase.auth().signInWithPopup(provider).then(result => { 
            commit('setToastMessage', { type: 'info', message: `${result.user.displayName} you are logged in with your Google account`, title: 'Google Login' })
        });
    },
    
    logout: async ({ commit, state }) => {

            //clear any seller tokens           

            await firebase.database().ref(`users/${state.user.uid}/fcmTokens/pwa/${state.selecteddevice}/${state.fcmToken}`).set(null).then(() => {
                console.log("token sent to server");
                return "token sent to server"
            })
            .catch(ex => {
                console.log(ex);
            });
       
            await firebase.auth().signOut().then(() => {
                commit('logout')
            });
       

    },

    unRegister: ({ commit, state }) => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .getRegistrations()
                .then(function (registrations) {
                    registrations.forEach(function (registration) {
                        registration.unregister();
                        console.log("Unregistered.");
                    }, this);

                }).then(() => {
                    window.location.reload(true);//reload after token cleared.
                });
        }
        else {
            window.location.reload(true);//reload after token cleared.
        }
    },

    setfcmToken(context, fcmToken) {
        context.commit('setfcmToken', fcmToken)
    }
}

export default new Vuex.Store({
    // strict: true,    
    plugins: [createLogger()],
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
})


// WEBPACK FOOTER //
// ./src/store/store.js